// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"icon-button_lightTheme__BN28Z"};